import React from "react";
import { Switch, Route } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import Incoming from "../pages/inventory/incoming";
import IncomingAdd from "../pages/inventory/incoming/form";
import IncomingEdit from "../pages/inventory/incoming/form/edit";
import Outgoing from "../pages/inventory/outgoing";
import OutgoingAdd from "../pages/inventory/outgoing/form";
import OutgoingEdit from "../pages/inventory/outgoing/form/edit";
import Pembongkaran from "../pages/inventory/pembongkaran";
import Tallying from "../pages/inventory/pembongkaran/form";
import TallySheetEdit from "../pages/inventory/pembongkaran/form/edit";
import Pemusnahan from "../pages/inventory/pemusnahan";
import PemusnahanAdd from "../pages/inventory/pemusnahan/form";
import Pemuatan from "../pages/inventory/pemuatan";
import PemuatanAdd from "../pages/inventory/pemuatan/form";

// Stock Opname
import Opname from "../pages/opname/";
import OpnameForm from "../pages/opname/form/index.js";

const InventoryRouter = () => {
  return (
    <TransitionGroup>
      <CSSTransition classNames="fadein" timeout={300}>
        <Switch>
          {/* Browse utama */}
          <Route path="/inventory/incoming" component={Incoming} />
          <Route path="/inventory/addincoming" component={IncomingAdd} />
          <Route
            path="/inventory/updateincoming/:idIncoming"
            component={IncomingEdit}
          />
          <Route path="/inventory/outgoing" component={Outgoing} />
          <Route path="/inventory/addoutgoing" component={OutgoingAdd} />
          <Route
            path="/inventory/updateoutgoing/:idOutgoing"
            component={OutgoingEdit}
          />
          <Route path="/inventory/tallying" component={Tallying} />
          <Route
            path="/inventory/updatetallysheet/:idStripping"
            component={TallySheetEdit}
          />
          <Route path="/inventory/pembongkaran" component={Pembongkaran} />
          <Route path="/inventory/pemusnahan" component={Pemusnahan} />
          <Route path="/inventory/addpemusnahan" component={PemusnahanAdd} />
          <Route path="/inventory/updatepemusnahan/:id" component={PemusnahanAdd} />
          <Route path="/inventory/pemuatan" component={Pemuatan} />
          <Route path="/inventory/addmuat" component={PemuatanAdd} />
          <Route path="/inventory/updatemuat/:id" component={PemuatanAdd} />

          {/* Stock Opname */}
          <Route path="/inventory/stock-opname" exact component={Opname} />
          <Route path="/inventory/stock-opname/add" component={OpnameForm} />
          <Route path="/inventory/stock-opname/edit/:id" component={OpnameForm} />

        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};
export default InventoryRouter;
